import {
  Box,
  Button,
  Flex,
  Icon,
  Image,
  List,
  ListIcon,
  ListItem,
  Progress,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/core";
import React from "react";

function ProfileCard({ profile }) {
  return (
    <Box p="10" px="20" backgroundColor="#0B0b19" color="white">
      <Flex justify="space-between" direction={{ lg: "row", base: "column" }}>
        <Box>
          <Flex align="center">
            <Image rounded="1em" src={profile.profilePic} size="90px" />
            <Box ml="5">
              <Text fontSize="lg">{profile.name}</Text>
              <Text fontSize="md" my="2">
                {profile.designation}
              </Text>
              <Stack isInline>
                <Flex align="center">
                  <Image src={profile.locationIcon} />
                  <Text mx="2" fontSize="sm">
                    {profile.location}
                  </Text>
                </Flex>
                <Flex align="Center">
                  <Image src={profile.expIcon} />
                  <Text mx="2" fontSize="sm">
                    {profile.experience}
                  </Text>
                </Flex>
                <Flex align="Center">
                  <Image src={profile.salaryIcon} />
                  <Text
                    mx="2"
                    fontSize="sm"
                  >{` ${profile.expectedSalary} | ${profile.desiredSalary}`}</Text>
                </Flex>
              </Stack>
            </Box>
          </Flex>
          <Box mt="8">
            <Box maxWidth="250px">
              <Flex justify="space-between">
                <Text>{`Profile Strength (${profile.strengthComment})`}</Text>
                <Text color="#41bb93">{`${profile.strength} %`}</Text>
              </Flex>
              <Progress
                my="2"
                height="0.25em"
                backgroundColor="white"
                color="green"
                size="sm"
                value={profile.strength}
              />
            </Box>
            <SimpleGrid minChildWidth="100px" spacing="1em" my="5">
              <Flex align="center">
                <Icon name="phone" />
                <Text mx="2">{profile.phone}</Text>
              </Flex>
              <Flex align="center">
                <Icon name="email" />
                <Text mx="2">{profile.mail}</Text>
              </Flex>
              <Button variant="outline">Verify</Button>
            </SimpleGrid>
          </Box>
        </Box>
        <Box color="black" rounded="0.5em" p="5" backgroundColor="white">
          <Text fontSize="xl">Suggestions</Text>
          <SimpleGrid minChildWidth="120px" spacing="1em" alignItems="end">
            <List mt="5">
              {profile.suggestion.add.map((each) => (
                <ListItem key={each}>
                  <ListIcon icon="minus" />
                  {`Add ${each}`}
                </ListItem>
              ))}
            </List>
            <Button backgroundColor="#41bb93">Get Started</Button>
          </SimpleGrid>
        </Box>
      </Flex>
    </Box>
  );
}

export default ProfileCard;
